import { render, staticRenderFns } from "./LayoutMain.vue?vue&type=template&id=894642de&"
import script from "./LayoutMain.vue?vue&type=script&lang=js&"
export * from "./LayoutMain.vue?vue&type=script&lang=js&"
import style0 from "./LayoutMain.vue?vue&type=style&index=0&id=894642de&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports